import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import useKeyPress from '../../../hooks/useKeyPress';

function ConnectedShortcutsWrapper({ playlists, storeRoute, storeHistory }) {

  const getPositionInPlaylists = useCallback(() => {
    if (storeHistory && storeHistory.history) {
      const h = storeHistory.history.find( x => (x.active && x.path.includes(`playlists`)) );
      if (h) {
        const id = h.path.split(`/`).pop();
        return playlists.findIndex( x => parseInt(x) === parseInt(id) );
      }
    }
    return -1;
  }, [storeHistory, playlists]);

  const keyUp = useKeyPress('ArrowUp', false, true, true, true);
  useEffect(() => {
    if (keyUp && playlists) {
      const index = (getPositionInPlaylists() - 1 < 0) ? 0 : getPositionInPlaylists() - 1;
      storeRoute.goTo(`/playlists/${playlists[index]}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyUp, playlists, storeRoute])

  const keyDown = useKeyPress('ArrowDown', false, true, true, true);
  useEffect(() => {
    if (keyDown && playlists) {
      const index = (getPositionInPlaylists() + 1 > playlists.length - 1) ? playlists.length - 1 : getPositionInPlaylists() + 1;
      storeRoute.goTo(`/playlists/${playlists[index]}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyDown, playlists, storeRoute])

  const keyDelete = useKeyPress('Backspace', true, true, true, true);
  useEffect(() => {
    if (keyDelete && playlists) {
      const id = playlists[getPositionInPlaylists()]
      if (id) {
        document.getElementById(`PM-D-${id}`).click();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyDelete, playlists])


  return null;
}

ConnectedShortcutsWrapper.propTypes = {
  playlists: PropTypes.array.isRequired,
  storeRoute: PropTypes.object.isRequired
}

const ShortcutsWrapper = connect(
  state => ({
    storeRoute: state.storeRoute,
    storeHistory: state.storeHistory
  })
)(ConnectedShortcutsWrapper);

export default ShortcutsWrapper;
